import { normalizeCountryCode } from "../domain/countries";

export type GeoHint = {
  country: string | null;
  countryName: string | null;
  source: "cf" | "none" | "error";
};

/** Fetch IP→country from Pages `/api/geo` (CF-IPCountry). Safe to call repeatedly. */
export async function fetchGeoHint(signal?: AbortSignal): Promise<GeoHint> {
  try {
    const res = await fetch("/api/geo", { method: "GET", credentials: "omit", signal });
    if (!res.ok) return { country: null, countryName: null, source: "error" };
    const data = (await res.json()) as {
      country?: string | null;
      countryName?: string | null;
      source?: string;
    };
    const country = normalizeCountryCode(data.country ?? null);
    return {
      country,
      countryName: country ? data.countryName ?? country : null,
      source: country ? "cf" : "none",
    };
  } catch {
    return { country: null, countryName: null, source: "error" };
  }
}
